import { atom, useAtom } from 'jotai';

export const selectedTeamIdAtom = atom(undefined);

export function useSelectedTeamIdAtom() {
    return useAtom(selectedTeamIdAtom);
  }